import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import { CoursePreviewFragmentDoc, UserPreviewFragmentDoc } from '../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ListUserGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListUserGroupsQuery = { __typename?: 'QueryRoot', allUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> };

export type CreateUserGroupMutationVariables = Types.Exact<{
  input: Types.CreateUserGroupInput;
}>;


export type CreateUserGroupMutation = { __typename?: 'MutationRoot', createUserGroup: { __typename?: 'UserGroup', id: string, name: string } };

export type CoursesVisibleToAllUserGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoursesVisibleToAllUserGroupsQuery = { __typename?: 'QueryRoot', coursesVisibleToAllUserGroups: Array<{ __typename?: 'Course', id: string, name: string, assetId: number, updatedAt: string, updatedBy: string, userGroup: { __typename?: 'UserGroup', id: string, name: string }, routeChangeAlert?: { __typename?: 'RouteChangeAlert', courseId: string, archiveFilePath: string, createdAt: string } | null }>, appConfig: { __typename?: 'AppConfig', routeChangeAlert: boolean } };


export const ListUserGroupsDocument = gql`
    query ListUserGroups {
  allUserGroups {
    id
    name
  }
}
    `;

export function useListUserGroupsQuery(options?: Omit<Urql.UseQueryArgs<ListUserGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListUserGroupsQuery, ListUserGroupsQueryVariables>({ query: ListUserGroupsDocument, ...options });
};
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($input: CreateUserGroupInput!) {
  createUserGroup(input: $input) {
    id
    name
  }
}
    `;

export function useCreateUserGroupMutation() {
  return Urql.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument);
};
export const CoursesVisibleToAllUserGroupsDocument = gql`
    query CoursesVisibleToAllUserGroups {
  coursesVisibleToAllUserGroups {
    ...CoursePreview
    userGroup {
      id
      name
    }
  }
  appConfig {
    routeChangeAlert
  }
}
    ${CoursePreviewFragmentDoc}`;

export function useCoursesVisibleToAllUserGroupsQuery(options?: Omit<Urql.UseQueryArgs<CoursesVisibleToAllUserGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<CoursesVisibleToAllUserGroupsQuery, CoursesVisibleToAllUserGroupsQueryVariables>({ query: CoursesVisibleToAllUserGroupsDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListUserGroupsQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ allUserGroups })
 *   )
 * })
 */
export const mockListUserGroupsQuery = (resolver: ResponseResolver<GraphQLRequest<ListUserGroupsQueryVariables>, GraphQLContext<ListUserGroupsQuery>, any>) =>
  graphql.query<ListUserGroupsQuery, ListUserGroupsQueryVariables>(
    'ListUserGroups',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateUserGroupMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createUserGroup })
 *   )
 * })
 */
export const mockCreateUserGroupMutation = (resolver: ResponseResolver<GraphQLRequest<CreateUserGroupMutationVariables>, GraphQLContext<CreateUserGroupMutation>, any>) =>
  graphql.mutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(
    'CreateUserGroup',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCoursesVisibleToAllUserGroupsQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ coursesVisibleToAllUserGroups, appConfig })
 *   )
 * })
 */
export const mockCoursesVisibleToAllUserGroupsQuery = (resolver: ResponseResolver<GraphQLRequest<CoursesVisibleToAllUserGroupsQueryVariables>, GraphQLContext<CoursesVisibleToAllUserGroupsQuery>, any>) =>
  graphql.query<CoursesVisibleToAllUserGroupsQuery, CoursesVisibleToAllUserGroupsQueryVariables>(
    'CoursesVisibleToAllUserGroups',
    resolver
  )
